import React from 'react';
import septaMark from '../../assets/branding/septa-logo.png';

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-black flex flex-col items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <img src={septaMark} alt="Septa" className="w-14 h-14 object-contain" />
        <div className="flex gap-1.5">
          {[0, 1, 2, 3].map(i => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-white animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
